export default __webpack_public_path__ + "static/media/chart.bb6a42b2.png";